<!-- <app-ada-message />
<app-play-break-message />
<app-arc-message /> -->
@switch (errorCode()) {
    @case (168) {
        <!-- ada message -->
        <show-message [type]="messageType.INFO">
            <div info>
                <p class="mb-2">{{ 'PARTY.CASHIER.web.ada.interaction.msg1' | translate }}</p>
                <p class="mb-2">{{ 'PARTY.CASHIER.web.ada.interaction.msg2' | translate }}</p>
                <p>{{ 'PARTY.CASHIER.web.ada.interaction.msg3' | translate }}</p>
                <span>
                    <b class="ada-msg mt-2">
                        <a (click)="submitAdaDeposit()" id="submitAdaDeposit">{{ 'PARTY.CASHIER.web.continue' | translate }} </a>
                        <a (click)="unblockForm()" id="unblockForm"> {{ 'PARTY.CASHIER.web.ada.interaction.adjust.amount' | translate }} </a>
                    </b>
                </span>
            </div>
        </show-message>
    }
    @case (169) {
        <!-- play break message  -->
        <show-message [type]="messageType.INFO">
            <div info>
                <strong>{{ 'PARTY.CASHIER.web.play.break.header' | translate }}</strong>
                <p>{{ 'PARTY.CASHIER.web.play.break.message' | translate }}</p>
            </div>
        </show-message>
    }
    @case (170) {
        @if (this.arcDepositBlockStatus?.depositBlocked) {
            <!-- deposit decline arc message -->
            <show-message [type]="messageType.ERROR">
                <div error>
                    <strong> {{ 'PARTY.CASHIER.web.arc.deposit.limits.intervention.declined.msg.header' | translate }} </strong>
                    <p>{{ 'PARTY.CASHIER.web.arc.deposit.limits.intervention.declined.msg.quote' | translate }}</p>
                    <br />
                    <p>{{ 'PARTY.CASHIER.web.arc.deposit.limits.intervention.blocked.body.msg1' | translate }}</p>
                    <br />
                    <p>
                        {{
                            'PARTY.CASHIER.web.arc.deposit.limits.intervention.blocked.body.msg2'
                                | translate
                                    : {
                                          hhmm: arcDepositBlockStatus?.expiryTime,
                                          date: arcDepositBlockStatus?.expiryDate,
                                      }
                        }}
                    </p>
                    <br />
                    <p
                        [vnDynamicHtml]="
                            'PARTY.CASHIER.web.arc.deposit.limits.intervention.blocked.body.msg3'
                                | translate
                                    : {
                                          clickHereUrl: arcDeclinedDepositClickHereUrl,
                                      }
                        "></p>
                </div>
            </show-message>
        }
    }
    @case (301) {
        <!-- bwinPLkycverification (redirect_deposit_amount_exceeded) -->
        <show-message [type]="messageType.INFO">
            <div info>
                <strong> {{ 'PARTY.CASHIER.web.deposit.kyc.301.msg1' | translate }} </strong>
                <p>
                    {{
                        'PARTY.CASHIER.web.deposit.kyc.301.msg2'
                            | translate
                                : {
                                      accountbalanceInfo: configParams?.userBalance | vnCurrency: currencyPLN,
                                  }
                    }}
                </p>
                <p>
                    {{
                        'PARTY.CASHIER.web.deposit.kyc.301.msg3'
                            | translate
                                : {
                                      amount: configParams?.depositLimit | vnCurrency: currencyPLN,
                                  }
                    }}
                </p>
                <div class="space-between mt-2">
                    <button type="submit" class="btn btn-primary" (click)="depositBack()">
                        {{ 'PARTY.CASHIER.web.deposit.kyc.301.msg4' | translate }}
                    </button>
                    <button type="button" class="btn btn-primary ml-2" (click)="submitPLDeposit()">
                        {{ 'PARTY.CASHIER.web.deposit.button' | translate }}
                    </button>
                </div>
            </div>
        </show-message>
    }
    @case (302) {
        <show-message [type]="messageType.INFO">
            <div info>
                <strong>
                    {{ 'PARTY.CASHIER.web.deposit.kyc.301.msg1' | translate }}
                </strong>
                <p>
                    {{
                        'PARTY.CASHIER.web.deposit.kyc.301.msg2'
                            | translate
                                : {
                                      accountbalanceInfo: configParams?.userBalance | vnCurrency: currencyPLN,
                                  }
                    }}
                </p>
                <p>
                    {{
                        'PARTY.CASHIER.web.deposit.kyc.302.msg1'
                            | translate
                                : {
                                      amount: configParams?.depositLimit | vnCurrency: currencyPLN,
                                  }
                    }}
                </p>
                <button type="button" class="btn btn-primary mt-2" (click)="submitPLDeposit()" id="submitPlDeposit">
                    {{ 'PARTY.CASHIER.web.deposit.kyc.301.msg5' | translate }}
                </button>
            </div>
        </show-message>
    }
}

<!-- <app-pl-verification-message /> -->

<!-- <app-pl-verification-message /> -->
@if (kycPLverification) {
    <show-message [type]="messageType.INFO">
        <div info>
            <strong>{{ 'PARTY.CASHIER.web.deposit.kyc.verification.msg1' | translate }}</strong>
            <p>{{ 'PARTY.CASHIER.web.deposit.kyc.verification.msg2' | translate }}</p>
            <button type="button" (click)="openKycRedirectUrl()" class="btn btn-primary mt-2">
                {{ 'PARTY.CASHIER.web.deposit.kyc.verify.message' | translate }}
            </button>
        </div>
    </show-message>
}

@if (sessionTimeout.status) {
    <show-message [type]="messageType.INFO">
        <div info>
            <strong>{{ 'PARTY.CASHIER.web.session.timeout.nl.header' | translate }}</strong>
            <p [vnDynamicHtml]="'PARTY.CASHIER.web.session.timeout.nl.message' | translate: { url: sessionTimeout.url }"></p>
        </div>
    </show-message>
}

<!-- reversal notification -->
@if (depositService?.QDType == 'GVCBETSLIP' && reversal?.isExists) {
    <show-message [type]="messageType.INFO" class="reversal-container">
        <div info class="reversal-notification">
            <strong>
                {{ 'PARTY.CASHIER.web.deposit.risk.player.message' | translate }}
                {{
                    'PARTY.CASHIER.web.deposit.pending.withdrawal'
                        | translate
                            : {
                                  amount: reversal.totalAmount | vnCurrency: reversal.data[0]?.redeemAmount?.currencyCode,
                              }
                }}
            </strong>
            <a class="reversal-link" (click)="gotoWithdrawal()" id="gotoWithdrawal">
                {{ 'PARTY.CASHIER.web.deposit.goto.withdrawal' | translate }}
            </a>
        </div>
    </show-message>
}

@if (isEsRiskPlayer) {
    <show-message [type]="messageType.INFO">
        <div info>
            <strong>
                {{ 'PARTY.CASHIER.web.deposit.risk.player.message' | translate }}
            </strong>
            <a (click)="liveChatUrlRisky()">
                <span class="float-right">
                    <b>{{ 'PARTY.CASHIER.web.arc.deposit.limits.intervention.liveChat' | translate }} </b>
                </span>
            </a>
        </div>
    </show-message>
}
